import React, { useState } from "react";
import { Country } from "../common/ObjectTypes";
import { AddIcon, DeleteIcon } from "../common/ProjectIcons";
import TextInput from "../common/TextInput";
import Pagination from "../common/Pagination";

type CountriesControllerTypes = {
  countries: Country[];
  selectedCountry: Country;
  countryToAdd: Country;
  addCountry: boolean;
  onClickAdd: Function;
  onSelectCountry: Function;
  onChange: Function;
  onChangeNewCountry: Function;
  onCancelEdit: Function;
  onCancelAdd: Function;
  onSaveNew: Function;
  onUpdateCountry: Function;
  onDelete: Function;
};

const CountriesController = ({
  countries,
  selectedCountry,
  countryToAdd,
  addCountry,
  onClickAdd,
  onSelectCountry,
  onChange,
  onChangeNewCountry,
  onCancelEdit,
  onCancelAdd,
  onSaveNew,
  onUpdateCountry,
  onDelete,
}: CountriesControllerTypes) => {
  const [subStr, setSubStr] = useState("");

  return (
    <div className="pt-6 bg-newGray-500 bg-opacity-50 px-6 ">
      <div className="flex flex-row justify-center">
        <div className="w-2/3">
          <h1 className="text-4xl text-center font-medium">Countries</h1>
          <div className="drop-shadow-lg bg-white w-full mt-6">
            <TextInput
              name={"name"}
              label={""}
              placeholder={"Search..."}
              value={subStr}
              error={""}
              disabled={false}
              className={"p-2 w-full rounded text-slate-300 shadow "}
              type={"text"}
              initialFocus={true}
              onChange={(e: any) => setSubStr(e.target.value)}
            />
          </div>
          <div className="drop-shadow-lg bg-white bg-opacity-70 h-96 p-2 overflow-scroll">
            <table className="w-full">
              <tbody>
                {countries
                  .filter((country: Country) =>
                    country.name.toLowerCase().includes(subStr)
                  )
                  .map((country: Country, index: number) => {
                    // Apply a different CSS class based on whether the index is odd or even
                    const rowClass =
                      index % 2 === 0 ? "bg-grayScale-400" : "bg-grayScale-200";

                    return (
                      <tr key={country.id} className={"" + rowClass}>
                        <td className="p-2 w-full">{country.name}</td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CountriesController;
